"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnnotationClearMessage = exports.isAnnotationLineEndMessage = exports.isAnnotationLinePointAddMessage = void 0;
const isAnnotationLinePointAddMessage = (msg) => msg.messageType === 'annotation-line-point-add';
exports.isAnnotationLinePointAddMessage = isAnnotationLinePointAddMessage;
const isAnnotationLineEndMessage = (msg) => msg.messageType === 'annotation-line-end';
exports.isAnnotationLineEndMessage = isAnnotationLineEndMessage;
const isAnnotationClearMessage = (msg) => msg.messageType === 'annotation-clear';
exports.isAnnotationClearMessage = isAnnotationClearMessage;
